import { components } from "react-select";
import userRoles from "../../../src/config/userRoles";
import {
  SALARY_COMPONENT_CALCULATION,
  SALARY_COMPONENT_TYPES,
  CALCUATION_FROM_VALUES,
  STATUTORY_COMPONENT_TYPE,
} from "../../../src/redux/constants/payrollComponents";
import { EMPLOYEE_ACCOUNT_STATUS } from "../../../src/redux/constants/actvityType";

export const carryForwardTypeOptions = [
  { label: "Number of days", value: 1 },
  { label: "Percentage", value: 2 },
];

export const employeeType = [
  { value: 2, label: "Permanent Employee" },
  { value: 3, label: "Part-time Employee" },
  { value: 4, label: "Temporary Employee" },
  { value: 5, label: "Intern" },
];

export const employementStatus = [
  { label: "Long Absence", value: EMPLOYEE_ACCOUNT_STATUS.LONG_ABSENCE },
  { label: "Terminated", value: EMPLOYEE_ACCOUNT_STATUS.TERMINATED },
  { label: "Resigned", value: EMPLOYEE_ACCOUNT_STATUS.RESIGNED },
  { label: "Onboarding", value: EMPLOYEE_ACCOUNT_STATUS.ONBOARDING },
  { label: "On leave", value: EMPLOYEE_ACCOUNT_STATUS.ON_LEAVE },
  { label: "Active", value: EMPLOYEE_ACCOUNT_STATUS.ACTIVE },
  { label: "Off-boarding", value: EMPLOYEE_ACCOUNT_STATUS.OFF_BOARDING },
  { label: "Probationary", value: EMPLOYEE_ACCOUNT_STATUS.PROBATIONARY },
];

export const leaveMode = [
  { value: 1, label: "Half Day" },
  { value: 2, label: "Full Day" },
];

export const sourceFrom = [
  { value: 5, label: "Advertisement" },
  { value: 6, label: "Social Media" },
  { value: 7, label: "Website" },
  { value: 8, label: "Job Apps" },
];

export const sourceOfHire = [
  { value: 6, label: "Employee Referrals" },
  { value: 7, label: "Campus Recruitment" },
  { value: 8, label: "Walk-in Interview" },
  { value: 9, label: "Staffing" },
  { value: 10, label: "Direct Recruitment" },
];

export const bloodGroup = [
  { value: "A+", label: "A+" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B-", label: "B-" },
  { value: "O+", label: "O+" },
  { value: "O-", label: "O-" },
  { value: "AB+", label: "AB+" },
  { value: "AB-", label: "AB-" },
];
export const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="ico-down text-blue-600"></span>
    </components.DropdownIndicator>
  );
};
export const bankNames = [
  // Original Banks
  { value: "SBI", label: "SBI" },
  { value: "AXIS", label: "AXIS" },
  { value: "ICICI", label: "ICICI" },

  // Qatar Domestic Banks
  { value: "Ahlibank", label: "Ahlibank" },
  { value: "Commercial Bank of Qatar", label: "Commercial Bank of Qatar" },
  { value: "Doha Bank", label: "Doha Bank" },
  { value: "Dukhan Bank", label: "Dukhan Bank" },
  { value: "Lesha Bank", label: "Lesha Bank" },
  { value: "Masraf Al Rayan", label: "Masraf Al Rayan" },
  { value: "Qatar Development Bank", label: "Qatar Development Bank" },
  {
    value: "Qatar International Islamic Bank",
    label: "Qatar International Islamic Bank",
  },
  { value: "Qatar Islamic Bank", label: "Qatar Islamic Bank" },
  { value: "Qatar National Bank", label: "Qatar National Bank" },

  // Foreign Banks in Qatar
  { value: "Arab Bank", label: "Arab Bank" },
  { value: "Bank Saderat Iran", label: "Bank Saderat Iran" },
  { value: "BNP Paribas", label: "BNP Paribas" },
  { value: "HSBC Bank Middle East", label: "HSBC Bank Middle East" },
  { value: "Mashreq Bank", label: "Mashreq Bank" },
  { value: "Standard Chartered Bank", label: "Standard Chartered Bank" },
  { value: "United Bank Limited", label: "United Bank Limited" },
];
export const accountTypes = [
  { value: "Current Account", label: "Current Account" },
  { value: "Savings account", label: "Savings account" },
  { value: "Salary account", label: "Salary account" },
];

export const shiftTypes = [
  { value: 1, label: "Clock based" },
  { value: 2, label: "Duration based" },
];
export const statusOptions = [
  { value: "1", label: "active" },
  { value: "0", label: "inactive" },
];

export const roleOptions = [
  { value: userRoles.TENANTADMIN, label: "Admin" },
  { value: userRoles.HR, label: "HR" },
  { value: userRoles.MANAGER, label: "Manager" },
  { value: userRoles.EMPLOYEE, label: "Employee" },
];

export const regularizationTypeOptions = [
  { value: 1, label: "Single Day" },
  { value: 2, label: "Multiple Days" },
];

export const regularizationStatusOptions = [
  { value: 1, label: "Approve" },
  { value: 2, label: "Pending" },
  { value: 3, label: "Reject" },
  { value: 4, label: "Cancel" },
];

export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
  // { value: "Non-Binary", label: "Non-Binary" },
  // { value: "Agender", label: "Agender" },
  // { value: "Bigender", label: "Bigender" },
  // { value: "Genderqueer", label: "Genderqueer" },
  // { value: "Genderfluid", label: "Genderfluid" },
  // { value: "Two-Spirit", label: "Two-Spirit" },
  // { value: "Prefer not to say", label: "Prefer not to say" },
];

export const residentialStatusOptions = [
  { value: "Resident", label: "Resident" },
  { value: "Non-resident", label: "Non-Resident" },
  { value: "Citizen", label: "Citizen" },
  { value: "Permanent-resident", label: "Permanent Resident" },
  { value: "Temporary-resident", label: "Temporary Resident" },
  { value: "Visa-holder", label: "Visa Holder" },
  { value: "Refugee-asylee", label: "Refugee/Asylee" },
  { value: "Undocumented", label: "Undocumented/Illegal Immigrant" },
];

export const employeeLevelOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
];

export const relationShipOptionList = [
  { label: "Parent", value: "Parent" },
  { label: "Sibling", value: "Sibling" },
  { label: "Spouse", value: "Spouse" },
  { label: "Child", value: "Child" },
  { label: "Grandparent", value: "Grandparent" },
  { label: "Grandchild", value: "Grandchild" },
  { label: "Aunt/Uncle", value: "Aunt/Uncle" },
  { label: "Niece/Nephew", value: "Niece/Nephew" },
  { label: "Cousin", value: "Cousin" },
  { label: "Friend", value: "Friend" },
  { label: "Colleague", value: "Colleague" },
  { label: "Supervisor", value: "Supervisor" },
  { label: "Employee", value: "Employee" },
  { label: "Mentor", value: "Mentor" },
  { label: "Student", value: "Student" },
];

export const titleOptions = [
  { label: "Mr.", value: "Mr." },
  { label: "Mrs.", value: "Mrs." },
  { label: "Ms.", value: "Ms." },
  { label: "Miss", value: "Miss" },
  { label: "Dr.", value: "Dr." },
  { label: "Prof.", value: "Prof." },
  { label: "Rev.", value: "Rev." },
  { label: "Sir", value: "Sir" },
  { label: "Madam", value: "Madam" },
];

export const holidayTypeOptions = [
  { value: 1, label: "Public Holiday" },
  { value: 2, label: "Regional Holiday" },
];

export const systemPolicyApprovalStatusOptions = [
  { value: 1, label: "Approved" },
  { value: 2, label: "Pending" },
  { value: 3, label: "Declined" },
];

export const systemPolicyStatusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "In active" },
];

export const documentApprovalStatusOptions = [
  { value: 1, label: "Approved" },
  { value: 2, label: "Pending" },
  { value: 3, label: "Declined" },
  { value: 4, label: "In-Process" },
  { value: 5, label: "Ready for approval" },
];

export const cancelReason = [
  { value: 1, label: "Wrong Input" },
  { value: 2, label: "System Error" },
  { value: 3, label: "Other" },
];

export const policyPayrollPrcessStatusOptions = [
  { value: 1, label: "Pending" },
  { value: 2, label: "Generated" },
  { value: 3, label: "Published" },
];

export const calculationMethodOption = [
  { label: "Calendar Days", value: "Calendar Days" },
  { label: "Working Days", value: "Working Days" },
];

export const calculationBasisOptions = [
  { label: "Monthly", value: "Monthly" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Half-Yearly", value: "Half-Yearly" },
  { label: "Yearly", value: "Yearly" },
];

export const calculationTypeOptions = [
  { label: "Fixed Amount", value: SALARY_COMPONENT_CALCULATION.FIXED_AMOUNT },
  { label: "Percentage", value: SALARY_COMPONENT_CALCULATION.PERCENTAGE },
  {
    label: "Auto Calculated",
    value: SALARY_COMPONENT_CALCULATION.AUTO_CALCULATED,
  },
];

export const calculationFromOptions = [
  { label: "Base", value: CALCUATION_FROM_VALUES.BASE },
  { label: "CTC", value: CALCUATION_FROM_VALUES.CTC },
];

export const statutoryComponentTypeOptions = [
  { label: "ESI", value: STATUTORY_COMPONENT_TYPE.ESI },
  { label: "EPF", value: STATUTORY_COMPONENT_TYPE.EPF },
  { label: "LWF", value: STATUTORY_COMPONENT_TYPE.LWF },
  { label: "PT", value: STATUTORY_COMPONENT_TYPE.PT },
  { label: "Other", value: STATUTORY_COMPONENT_TYPE.OTHER },
];
export const componentTypeOptions = [
  { label: "Deductions", value: SALARY_COMPONENT_TYPES.DEDUCTION },
  { label: "Earnings", value: SALARY_COMPONENT_TYPES.EARNING },
  { label: "TDS", value: SALARY_COMPONENT_TYPES.TDS },
];
